import { jsx as _jsx } from "react/jsx-runtime";
import { CreditCard } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { PaymentTest } from './routes/test.js';
// Fail-closed default: a module rendered outside the shell's provider shows the
// read-only operations, never the cancels.
const { Provider: PaymentModulePermsProvider, usePerms: usePaymentPerms } = createModulePerms({ canRunAdminOps: false });
export { PaymentModulePermsProvider };
function PaymentTestRoute() {
    const { canRunAdminOps } = usePaymentPerms();
    return _jsx(PaymentTest, { canRunAdminOps: canRunAdminOps });
}
/**
 * Sidebar entry «Платёжный сервис». The single index route serves the test tool
 * (operation probe against the real wit-payment-service) with the read-only
 * request history rendered below it. Gated `subscription.read`; cancel
 * operations additionally require `payment.admin_ops` server-side — and are
 * hidden client-side for anyone without it.
 */
export const paymentModule = {
    id: 'payment',
    label: 'Платёжный сервис',
    icon: CreditCard,
    permission: 'subscription.read',
    workspace: 'risk',
    order: 93,
    description: 'Тест запросов к платёжному сервису WIT (биллинг, проверки, отмена) и журнал прошлых обращений.',
    showInNav: true,
    routes: [{ path: '/', component: PaymentTestRoute }],
};
export { PaymentTest } from './routes/test.js';
export { PaymentHistory } from './routes/history.js';
export { setPaymentApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map